import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, features, featuredContent, scheduleData, faqItems, articles, siteConfig } from '@/mocks/content';

function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20entertainment%20scene%20with%20cozy%20living%20room%2C%20large%20TV%20screen%20with%20colorful%20abstract%20content%2C%20soft%20golden%20ambient%20lighting%2C%20modern%20interior%20design%2C%20warm%20atmospheric%20glow%2C%20comfortable%20and%20inviting%20atmosphere%2C%20clean%20aesthetic%20photography&width=1800&height=800&seq=bytv-hero-bg&orientation=landscape"
        alt="bytv 视频平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-5 tracking-wide leading-tight">
          畅享海量精彩内容
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          {siteConfig.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            立即开始观看
          </a>
          <Link
            to="/category/zongyi"
            className="px-8 py-3.5 text-sm font-semibold rounded-full border-2 border-white/40 text-white hover:bg-white/15 hover:border-white/70 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览频道
          </Link>
        </div>
        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">2亿+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">月活跃用户</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">10万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">小时内容</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">8大</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">核心频道</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            为什么选择 bytv
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            四大核心优势，为您带来极致的在线视频观看体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 hover:bg-background-200/80 transition-colors duration-300 group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            探索频道
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            八大核心频道，满足全家人的观看需求
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 hover:bg-primary-50 hover:shadow-sm transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function HotContentSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">精选优质内容，一站式观看体验</p>
          </div>
          <Link
            to="/category/zongyi"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredContent.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden hover:shadow-sm transition-all duration-300"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {item.badge && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    {item.badge}
                  </span>
                )}
                <div className="absolute bottom-3 right-3 px-2 py-0.5 text-xs font-medium rounded bg-black/60 text-white whitespace-nowrap">
                  <i className="ri-star-fill text-primary-400 text-xs mr-1"></i>
                  {item.rating}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs whitespace-nowrap">
                    {item.category}
                  </span>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function ScheduleSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100" id="schedule">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            今日节目表
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精彩节目不间断，随时掌握播出动态
          </p>
        </div>
        <div className="max-w-3xl mx-auto bg-background-50 rounded-xl overflow-hidden">
          {scheduleData.map((item, i) => (
            <Link
              key={i}
              to={`/category/${item.categorySlug}`}
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors duration-200 cursor-pointer ${
                i < scheduleData.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <span className="text-sm font-mono font-semibold text-foreground-700 w-14 whitespace-nowrap">
                {item.time}
              </span>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-foreground-900">{item.program}</span>
              </div>
              <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                {item.category}
              </span>
              {item.status === 'live' && (
                <span className="flex items-center gap-1 px-2.5 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-600 whitespace-nowrap">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"></span>
                  直播中
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function ArticlesPreviewSection() {
  const previewArticles = articles.slice(0, 3);
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-500">bytv 最新动态与观影攻略</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {previewArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden hover:shadow-sm transition-all duration-300"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于 bytv 的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20golden%20and%20amber%20flowing%20shapes%2C%20modern%20digital%20atmosphere%2C%20clean%20minimal%20design%2C%20smooth%20curves%2C%20warm%20inviting%20color%20palette&width=1800&height=500&seq=bytv-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 to-foreground-900/70"></div>
      <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">
          准备好开启您的观影之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 leading-relaxed">
          立即加入 bytv，畅享 10万+ 小时正版高清内容。新用户注册即享 7 天免费会员体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            免费注册体验
          </a>
          <Link
            to="/about"
            className="px-8 py-3.5 text-sm font-semibold rounded-full border-2 border-white/30 text-white hover:bg-white/10 hover:border-white/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}

function HomeSchemaScript() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: 'bytv',
        url: 'https://8cc6u.cn',
        description: siteConfig.description,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-2888',
          contactType: 'customer service',
          availableLanguage: 'Chinese',
        },
      },
      {
        '@type': 'WebSite',
        url: 'https://8cc6u.cn',
        name: 'bytv 视频平台',
        description: siteConfig.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://8cc6u.cn/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        url: 'https://8cc6u.cn',
        name: 'bytv官方落地页 | bytv在线观看与服务入口',
        description: siteConfig.description,
        isPartOf: { '@id': 'https://8cc6u.cn/#website' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqItems.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);

  return (
    <>
      <HomeSchemaScript />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturesSection />
        <CategoriesSection />
        <HotContentSection />
        <ScheduleSection />
        <ArticlesPreviewSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}